import { ParseHandlers } from './ParseHandlers';

import type { EntityCommand } from 'owa-graph-schema';
import type { OwaNovaAction, OwaNovaKind } from 'owa-nova-actions';

export default function parseNovaCommand(command: EntityCommand): OwaNovaAction<OwaNovaKind> {
    for (let i = 0; i < ParseHandlers.length; i++) {
        let handler = ParseHandlers[i];
        let action = handler(command);
        if (!!action) {
            return action;
        }
    }

    throw new Error(`Nova command was not parsed ${command.entity.entityId}`);
}
